import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { ECharts } from 'echarts';
import * as echarts from 'echarts';
import * as _ from 'lodash';
import { initOpts } from '../../config/initOpts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { WebGLMapService } from './web-gl-map.service';
import { cloneDeep } from 'lodash';
import 'echarts-gl';
@Component({
  selector: 'bcac-web-gl-map',
  templateUrl: './web-gl-map.component.html',
  styleUrls: ['./web-gl-map.component.scss']
})
export class WebGLMapComponent implements OnInit {

  constructor(
    private webGLMapService: WebGLMapService,
    private commonService: CommonService,
    private http: HttpClient
  ) { }

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      let style = this.commonService.changeFontSize();
      this.commonService.setMapChartResize(this.echartInstance, style);
    })
  }

  _mapName: string = 'mapName';
  chartOption: any = this.webGLMapService.getWebGLMapDefaultOptions(this._mapName);
  _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "地图"
  }

  // 输入标题
  @Input()
  set bcacChartTitleText(chartTitle: string) {
    this._bcacChartTitle.label = chartTitle
  }
  // 输入标题是否显示
  @Input()
  set bcacChartShowTitle(showTitle: boolean) {
    this._bcacChartTitle.show = showTitle
  }
  // 下载图片文件名
  _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }

  // 地图文件路径
  _mapUrl: string = '';
  @Input()
  set bcacMapUrl(mapUrl: string) {
    if (!_.isNil(mapUrl)) {
      this._mapUrl = mapUrl;
    }
    this.updateMapUrl();
  }

  // 下拉框列表数据
  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];
  // 数据选择区域
  @Input()
  set bcacDataSourceList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && selectList[0].hasOwnProperty('optList')) {
        this._selectList = selectList;
      } else {
        this._selectList = [];
      }
    } else {
      this._selectList = []
    }
  }


  visualMapType = "piecewise";
  visualMapPosition: 'left' | 'right' = 'left';
  bcacData: any
  // 图数据
  @Input()
  set bcacChartData(chartData: any) {
    if (chartData && chartData.hasOwnProperty('data')) {
      if (chartData && chartData.hasOwnProperty('visualMap') && chartData.visualMap.hasOwnProperty('type')) {
        this.visualMapType = chartData.visualMap.type;
      }
      // this.bcacData = cloneDeep(chartData);
      // let dataSourceList = [], selectedIndex = 0;

      // if (chartData.length !== 1) {
      //   this.isNotSingleData = true;
      // }

      // for (let i = 0; i < chartData.length; i++) {
      //   dataSourceList.push({ label: chartData[i].name, value: chartData[i].name })
      // }

      // this.bcacData = cloneDeep(chartData);
      // this.dataSourceList = dataSourceList;

      // chartData.forEach((item, index) => {
      //   if (item.selected) {
      //     selectedIndex = index;
      //     return;
      //   }
      // })

      // this.selectedData = dataSourceList[selectedIndex].value;
      let unit = '';
      if (chartData.hasOwnProperty('visualMap') && chartData.visualMap.hasOwnProperty('type') && chartData.visualMap.hasOwnProperty('unit')) {
        unit = chartData.visualMap.unit;
      }

      this.webGLMapService.changeVisualMap(this.chartOption, this.visualMapPosition, chartData.visualMap, this._bcacDimension, unit)
      this.webGLMapService.changeChartData(this.chartOption, chartData.data)

    }
    else {
      this.webGLMapService.changeChartData(this.chartOption, [])
    }
    this.updateOption();
  }

  _bcacDimension: number = 0;
  @Input()
  set bcacDimension(dimension: number) {

    this._bcacDimension = dimension;
    this.webGLMapService.changeVisualmapDimension(this.chartOption, dimension)
    this.updateOption();
  }

  // 设置dimension名
  @Input()
  set bcacDimensionNames(dimensionNames: { [key: string]: string }[]) {
    this.webGLMapService.changeDimensionNames(this.chartOption, dimensionNames)
    this.updateOption();
  }
  // 更改visualMap位置
  @Input()
  set bcacVisualMapPosition(position: 'left' | 'right') {
    this.visualMapPosition = position;
    this.webGLMapService.changeVisualMapPosition(this.chartOption, position)
    this.updateOption();
  }

  isSmallMode: boolean = false;
  _cardPadding = "1rem";
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true
      this.changeCardPadding(smallMode);
    } else {
      this.isSmallMode = false;
    }
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();


  echartInstance: ECharts;
  onOptionInit($event) {
    this.echartInstance = $event;
  }

  updateOption() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.chartOption, true)
    }
  }

  updateMapUrl() {
    this.http.get(this._mapUrl).subscribe((geoJson) => {
      echarts.registerMap('mapName', geoJson);
      // this.webGLMapService.changeGeo3d(this.chartOption, this._mapName);
      // this.webGLMapService.changeSeries(this.chartOption);
      if (this.echartInstance) {
        this.echartInstance.setOption(this.chartOption)
      }
    })
  }

  isNotSingleData: boolean = false;

  dataSourceList: { name: string, data: any }[] = [];

  selectedData: string = "";

  // 改变数据源
  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if (element.name === $event) {
        this.webGLMapService.changeVisualMap(this.chartOption, element.visualMap, this._bcacDimension);
        this.webGLMapService.changeChartData(this.chartOption, element.data);
        this.updateOption();
        return;
      }
    })
  }

  chartRestore() {
    if (this.echartInstance) {
      this.echartInstance.dispatchAction({
        type: 'restore'
      })
    }
  }

  selectedDataSourceChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  changeCardPadding(smallMode: boolean) {
    if (smallMode) {
      this._cardPadding = "0rem";
    } else {
      this._cardPadding = "1rem";
    }
  }
}



